import React from 'react';
import './LegalPage.css';

export default function PrivacyPolicy() {
  return (
    <div className="legal-page">
      <div className="legal-shell">
        <section className="legal-hero">
          <span className="legal-kicker">Privacy</span>
          <h1>Privacy Policy</h1>
          <p>
            This policy explains what information Anora Store collects, how we use it to fulfill orders and support requests,
            and what third-party tools help us run the store.
          </p>
          <div className="legal-updated">Last updated: March 31, 2026</div>
        </section>

        <div className="legal-content">
          <section className="legal-card">
            <h2>Information we collect</h2>
            <ul>
              <li>Order details you submit during checkout, including name, shipping address, email, and payment method metadata.</li>
              <li>Support ticket details you provide when you contact us through the site.</li>
              <li>Basic analytics signals, such as page views and site usage, through Google Analytics.</li>
            </ul>
          </section>

          <section className="legal-card">
            <h2>How we use your information</h2>
            <ul>
              <li>To process orders, calculate shipping, and provide order tracking.</li>
              <li>To respond to support questions and follow up on open issues.</li>
              <li>To monitor store performance, improve the browsing experience, and understand which products people engage with.</li>
            </ul>
          </section>

          <section className="legal-card">
            <h2>Services we rely on</h2>
            <ul>
              <li>Stripe and PayPal help process payments securely.</li>
              <li>Shipping providers and label services may receive the delivery details needed to fulfill your order.</li>
              <li>Google Analytics helps us understand traffic and page activity.</li>
              <li>eBay listing data may be synced into our storefront when items are imported from our seller account.</li>
            </ul>
          </section>

          <section className="legal-card">
            <h2>Retention and security</h2>
            <p>
              We keep order and support information only as long as needed to operate the store, resolve issues, and maintain business records.
              Store administration is protected by restricted admin access, and payment card data is handled by the payment processors rather than stored directly by us.
            </p>
          </section>

          <section className="legal-card">
            <h2>Your questions</h2>
            <p>
              If you need help with an order or want to ask about how your information is used, visit our <a href="/support">Support Center</a>
              {' '}or call <a href="tel:5612851789">561-285-1789</a>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
